// ClinicOS — English translations
export const en: Record<string, string> = {
    // Navigation
    'nav.dashboard': 'Dashboard',
    'nav.patients': 'Patients',
    'nav.appointments': 'Appointments',
    'nav.encounters': 'Encounters',
    'nav.telehealth': 'Telehealth',
    'nav.messages': 'Messages',
    'nav.settings': 'Settings',
    'nav.dailyOverview': 'Daily Overview',
    'nav.staff': 'Staff',
    'coordinator.subtitle': 'Coordination Panel',

    // Dashboard
    'dashboard.title': 'Dashboard',
    'dashboard.today_appointments': 'Today\'s Appointments',
    'dashboard.total_patients': 'Total Patients',
    'dashboard.pending_notes': 'Pending Notes',
    'dashboard.welcome': 'Welcome, {name}',

    // Patients
    'patients.title': 'Patients',
    'patients.search': 'Search patients...',
    'patients.new': 'New Patient',
    'patients.name': 'Name',
    'patients.cedula': 'ID Number',
    'patients.phone': 'Phone',
    'patients.dob': 'Date of Birth',
    'patients.gender': 'Gender',
    'patients.gender.male': 'Male',
    'patients.gender.female': 'Female',
    'patients.gender.other': 'Other',
    'patients.insurance': 'Insurance',
    'patients.view': 'View Patient',
    'patients.no_results': 'No patients found',

    // Appointments
    'appointments.title': 'Appointments',
    'appointments.new': 'New Appointment',
    'appointments.date': 'Date',
    'appointments.time': 'Time',
    'appointments.doctor': 'Doctor',
    'appointments.patient': 'Patient',
    'appointments.type': 'Type',
    'appointments.type.in_person': 'In Person',
    'appointments.type.telehealth': 'Telehealth',
    'appointments.status': 'Status',
    'appointments.status.booked': 'Booked',
    'appointments.status.confirmed': 'Confirmed',
    'appointments.status.arrived': 'Arrived',
    'appointments.status.in_progress': 'In Progress',
    'appointments.status.completed': 'Completed',
    'appointments.status.cancelled': 'Cancelled',
    'appointments.reason': 'Chief Complaint',

    // SOAP Notes
    'soap.title': 'SOAP Note',
    'soap.subjective': 'Subjective',
    'soap.objective': 'Objective',
    'soap.assessment': 'Assessment',
    'soap.plan': 'Plan',
    'soap.diagnoses': 'Diagnoses',
    'soap.medications': 'Medications',
    'soap.vitals': 'Vitals',
    'soap.sign': 'Sign Note',
    'soap.save_draft': 'Save Draft',
    'soap.signed': 'Signed',
    'soap.ai_draft': 'AI Draft',
    'soap.voice_scribe': 'Voice Scribe',

    // Billing
    'billing.title': 'Billing',
    'billing.invoices': 'Invoices',
    'billing.total': 'Total',
    'billing.status.draft': 'Draft',
    'billing.status.sent': 'Sent',
    'billing.status.paid': 'Paid',
    'billing.status.overdue': 'Overdue',

    // Common
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.delete': 'Delete',
    'common.edit': 'Edit',
    'common.close': 'Close',
    'common.loading': 'Loading...',
    'common.confirm': 'Confirm',
    'common.back': 'Back',
    'common.search': 'Search',
    'common.filter': 'Filter',
    'common.actions': 'Actions',
    'common.yes': 'Yes',
    'common.no': 'No',
    'common.coming_soon': '🚧 Coming Soon',

    // Auth
    'auth.login': 'Sign In',
    'auth.logout': 'Sign Out',
    'auth.welcome': 'Welcome',
};
